import React from "react";
import {
  CloseIcon,
  InstallIcons,
  InstallIconsContainer,
  LogoImg,
  OpenInWebButton,
  PopUpContainer,
  PopUpHeader,
  PopUpSubtitle,
  PopUpTitle,
  QRCodeImage,
  StyledCustomExternalLink,
  WebIconImg,
} from "./SignUpPopUp.styles";
import goolgePlayIcon from "@assets/icons/google-play-large.svg";
import webIcon from "@assets/icons/icons8-internet-50.apng.png";

export function SignUpPopUp({ setIsOpen }) {
  return (
    <PopUpContainer>
      <PopUpHeader>
        <LogoImg src="/logo-pink.svg" />
        <CloseIcon onClick={() => setIsOpen(false)} />
      </PopUpHeader>
      <PopUpTitle>Get the Tatva App</PopUpTitle>
      <PopUpSubtitle>Scan the QR code or open in your browser</PopUpSubtitle>
      <QRCodeImage src={process.env.GATSBY_WEBAPP_QR_URL} />
      <InstallIconsContainer>
        <StyledCustomExternalLink
          href="https://play.google.com/store/apps/details?id=app.tatva"
          target="_blank"
        >
          <InstallIcons src={goolgePlayIcon} />
        </StyledCustomExternalLink>

        <OpenInWebButton
          href={`${process.env.GATSBY_WEBAPP_BASE_URL}/download`}
          target="_blank"
          rel="noreferrer"
        >
          <WebIconImg src={webIcon} alt="Web" />
          Open in Web
        </OpenInWebButton>
      </InstallIconsContainer>
    </PopUpContainer>
  );
}

export default SignUpPopUp;
